import { atom } from 'jotai';

interface INotification {
  id: string,
  type?: 'ALERT'|'ERROR'|'SUCCESS',
  content: string,
  timeout?: number
}

export const notificationsAtom = atom<INotification[]>([]);
export const addNotificationAtom = atom(null, (get, set, notification: INotification) => {
  set(notificationsAtom, (prevNotifications) => [...prevNotifications, notification]);
});
export const removeNotificationAtom = atom(null, (get, set, id: string) => {
  set(notificationsAtom, (prevNotifications) => prevNotifications.filter((n) => n.id !== id));
});
